import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
// material-ui
import { useTheme } from '@mui/material/styles';
import {
  Avatar,
  Box,
  Button,
  ButtonBase,
  Typography,
  Chip,
  Stack,
  Paper // ← AGREGAR ESTO
} from '@mui/material';
import {
  AccessTime,
  Public // ← AGREGAR ESTO
} from '@mui/icons-material';
// project imports
import ProfileSection from './ProfileSection';
import { getHotelMoment } from 'utils/timeZone';
// assets
import { IconMenu2 } from '@tabler/icons';
import LogoSection from '../LogoSection';
import NotificationSection from './NotificationSection';
import LogoutButton from './LogoutButton';

// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const Header = ({ handleLeftDrawerToggle }) => {
  const theme = useTheme();

  const hotel = JSON.parse(localStorage.getItem('hotelData'));
  console.log('in in header section hotel===>', hotel);

  const [time, setTime] = useState(getHotelMoment().format('hh:mm:ss A'));

  useEffect(() => {
    const timer = setInterval(() => {
      setTime(getHotelMoment().format('hh:mm:ss A'));
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <>
      {/* Logo & Menu Toggle Button */}
      <Box
        sx={{
          width: 228,
          display: 'flex',
          alignItems: 'center',
          [theme.breakpoints.down('md')]: {
            width: 'auto'
          }
        }}
      >
        <Box component="span" sx={{ display: { xs: 'none', md: 'block' }, flexGrow: 1 }}>
          <LogoSection />
        </Box>
        <ButtonBase
          sx={{
            borderRadius: '12px',
            overflow: 'hidden',
            ml: { xs: 0, md: 1 }
          }}
        >
          <Avatar
            variant="rounded"
            sx={{
              ...theme.typography.commonAvatar,
              ...theme.typography.mediumAvatar,
              transition: 'all .2s ease-in-out',
              background: theme.palette.secondary.light,
              color: theme.palette.secondary.dark,
              '&:hover': {
                background: theme.palette.secondary.dark,
                color: theme.palette.secondary.light
              }
            }}
            onClick={handleLeftDrawerToggle}
            color="inherit"
            aria-label="Toggle navigation menu"
          >
            <IconMenu2 stroke={1.5} size="1.3rem" />
          </Avatar>
        </ButtonBase>
      </Box>

      {/* Welcome Message */}
      <Box sx={{ mx: 2, display: { xs: 'none', md: 'block' } }}>
        {hotel.role === 'HotelAdmin' ? (
          <Stack spacing={0.25}>
            <Typography
              variant="h4"
              sx={{
                color: theme.palette.primary.main,
                fontWeight: 600,
                lineHeight: 1.2
              }}
            >
              Bienvenido a {hotel.name}
            </Typography>
            <Typography
              variant="caption"
              sx={{
                color: theme.palette.text.secondary,
                fontSize: '0.75rem'
              }}
            >
              Panel de Administración
            </Typography>
          </Stack>
        ) : hotel.role === 'admin' ? (
          <Stack spacing={0.25}>
            <Typography
              variant="h4"
              sx={{
                color: theme.palette.primary.main,
                fontWeight: 600,
                lineHeight: 1.2
              }}
            >
              Welcome, Admin {hotel.firstName}
            </Typography>
            <Typography
              variant="caption"
              sx={{
                color: theme.palette.text.secondary,
                fontSize: '0.75rem'
              }}
            >
              System Administrator
            </Typography>
          </Stack>
        ) : (
          <Stack spacing={0.25}>
            <Typography
              variant="h4"
              sx={{
                color: theme.palette.primary.main,
                fontWeight: 600,
                lineHeight: 1.2
              }}
            >
              Welcome, {hotel.firstName}
            </Typography>
            <Typography
              variant="caption"
              sx={{
                color: theme.palette.text.secondary,
                fontSize: '0.75rem'
              }}
            >
              {hotel.role === 'supervisor' ? 'Supervisor' : hotel.role === 'receptionist' ? 'Recepcionista' : 'Staff Member'}
            </Typography>
          </Stack>
        )}
      </Box>

      {/* Header Search removed by comment above */}

      <Box sx={{ flexGrow: 1 }} />
      <Box sx={{ flexGrow: 1 }} />

      {/* Hotel Time Clock - Enhanced Version */}
      <Box sx={{ display: { xs: 'none', sm: 'block' }, mr: 3 }}>
        <Paper
          elevation={0}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            px: 2,
            py: 1,
            borderRadius: 2,
            border: `1px solid ${theme.palette.divider}`,
            backgroundColor: theme.palette.background.paper,
            transition: 'all 0.2s ease',
            '&:hover': {
              borderColor: theme.palette.primary.main,
              boxShadow: `0 0 0 1px ${theme.palette.primary.main}20`
            }
          }}
        >
          {/* Icon with pulse animation */}
          <Box
            sx={{
              position: 'relative',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <AccessTime
              sx={{
                color: theme.palette.primary.main,
                fontSize: 20,
                zIndex: 1
              }}
            />
            {/* Pulse effect */}
            <Box
              sx={{
                position: 'absolute',
                width: '100%',
                height: '100%',
                borderRadius: '50%',
                backgroundColor: theme.palette.primary.main,
                opacity: 0.2,
                animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite',
                '@keyframes pulse': {
                  '0%, 100%': {
                    transform: 'scale(1)',
                    opacity: 0.2
                  },
                  '50%': {
                    transform: 'scale(1.3)',
                    opacity: 0
                  }
                }
              }}
            />
          </Box>

          {/* Time Display */}
          <Stack spacing={0.25}>
            <Typography
              variant="body1"
              sx={{
                fontWeight: 600,
                color: theme.palette.text.primary,
                fontSize: '0.95rem',
                lineHeight: 1,
                fontVariantNumeric: 'tabular-nums', // Monospace numbers
                letterSpacing: '0.5px'
              }}
            >
              {time}
            </Typography>
            <Typography
              variant="caption"
              sx={{
                color: theme.palette.text.secondary,
                fontSize: '0.7rem',
                lineHeight: 1,
                display: 'flex',
                alignItems: 'center',
                gap: 0.5
              }}
            >
              <Public sx={{ fontSize: 11 }} />
              {hotel?.timezone?.split('/')[1]?.replace('_', ' ') || 'Hotel Time'}
            </Typography>
          </Stack>
        </Paper>
      </Box>

      {/* notification & profile */}
      <ProfileSection />
      <LogoutButton />
      {/* <Button variant="contained" sx={{mx : 2}} > Logout </Button> */}
    </>
  );
};

Header.propTypes = {
  handleLeftDrawerToggle: PropTypes.func
};

export default Header;
